import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, makeStyles, Theme, Typography } from '@material-ui/core';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { InvestorIntro } from '../../types/types';
import Button from '../../components/Button';
import TextInput from '../../components/TextInput';
import Form from '../../components/Form';
import { formikSubmitDisabled } from '../../lib/utils';
import { investorPublishedIntroSchema, optionalUrlTest } from '../../lib/validationSchemas';


const initialValues = (profile: InvestorIntro) => ({
  contactName: profile.contactName || '',
  companyName: profile.companyName || '',
  email: profile.email || '',
  intro: profile.intro || '',
  linkedinProfile: profile.linkedinProfile || ''
});

export const unpublishedInvestorIntroValidationSchema = Yup.object().shape({
  contactName: Yup.string().trim(),
  companyName: Yup.string().trim(),
  email: Yup.string().email(),
  intro: Yup.string().trim(),
  linkedinProfile: optionalUrlTest
});

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: theme.spacing(0),
    minWidth: 400
  },
  dialogActions: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 24px'
  }
}));

interface InvestorIntroPanelEditProps {
  open: boolean
  investorIntro: InvestorIntro
  published: boolean
  handleSubmit: (values: InvestorIntro) => void
  handleClose: () => void
}

const InvestorIntroPanelEdit: React.FC<InvestorIntroPanelEditProps> = ({
  open, investorIntro, handleSubmit, handleClose, published
}) => {
  const styles = useStyles();
  const formik = useFormik({
    initialValues: initialValues(investorIntro),
    validationSchema: published ? investorPublishedIntroSchema : unpublishedInvestorIntroValidationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true
  });

  const handleCancel = () => {
    handleClose();
    formik.resetForm();
  };

  return (
    <Dialog
      open={open}
      className={styles.root}
      onClose={handleClose}
    >
      <Form formik={formik}>
        <DialogTitle disableTypography>
          <Typography variant='h2'>Investor Info</Typography>
        </DialogTitle>
        <DialogContent>
          <TextInput
            type='text'
            fullWidth
            id='contactName'
            label='Contact Name'
            placeholder='Investor Name'
          />
          <TextInput
            type='text'
            fullWidth
            id='companyName'
            label='Company Name'
            placeholder='Name of the company'
          />
          <TextInput
            type='text'
            fullWidth
            multiline
            rows={5}
            id='intro'
            label='Investor Bio'
            placeholder='Short Introduction'
          />
          <TextInput
            type='text'
            fullWidth
            id='email'
            label='Email'
            placeholder='Email'
          />
          <TextInput
            type='text'
            fullWidth
            id='linkedinProfile'
            label='Linkedin Profile Link'
            placeholder='https://linkedin.com/in/investor-name'
          />
        </DialogContent>
        <DialogActions className={styles.dialogActions}>
          <Button variant='text' color='primary' type='button' onClick={handleCancel}>Cancel</Button>
          <Button type='submit' disabled={formikSubmitDisabled(formik)}>Save</Button>
        </DialogActions>
      </Form>
    </Dialog>
  );
};

export default InvestorIntroPanelEdit;

